import { connect } from 'react-redux';
import { Route } from './Route.component';
import { ROUTES, VIEWER_PERMISSIONS_GROUP } from 'shared/constants';
import { hasPermission, isAuthenticated } from 'shared/store/selectors/auth.selector';

const mapStateToProps = ({ auth }, { permissions = VIEWER_PERMISSIONS_GROUP }) => {
  return {
    rootPath: ROUTES.HOME,
    isHavePermissions: hasPermission({ auth, permissions }),
    isAllowedRoute: !isAuthenticated({ auth }),
    redirectRoute: ROUTES.WELCOME,
    shouldCaptureIntendedRoute: true,
    auth,
  };
};

export const PrivateRoute = connect(mapStateToProps)(Route);
